import PropertyInputV2 from 'customer-data-properties/input/PropertyInputV2';
import { usePropertyDisplay } from '../hooks/usePropertyDisplay';
import { useCardContextValue } from '../state/CardContext';
import { useCallback, useMemo, useState } from 'react';
import { usePropertyInputsContextValue } from '../state/PropertyInputsContext';
import styled, { css } from 'styled-components';
import { isEnum } from 'customer-data-objects/property/PropertyIdentifier';
import { castPropertyToAny } from '../utils/properties';
import { jsx as _jsx } from "react/jsx-runtime";
const inputStyles = css(["textarea,input{height:auto;min-height:auto;padding:", ";border:", ";}input[type='text'],textarea{display:block;margin-block-start:2px;max-height:22px;line-height:22px;white-space:nowrap;}button{min-height:auto;&[data-dropdown='true'],&[data-button-use='form']{padding-block-start:0 !important;}&[data-dropdown='true']{display:block;line-height:22px;margin-block-start:2px;}}"], ({
  theme
}) => theme.space['0'], ({
  theme
}) => theme.borderWidth['0']);
const InputWrapper = styled.div.withConfig({
  displayName: "PropertyInputWrapper__InputWrapper",
  componentId: "vojoox-0"
})(["", ""], inputStyles);
const PropertyInputWrapper = ({
  propertyName,
  inputProps = {},
  formControlProps = {},
  onFocus,
  onBlur,
  isEditable = true,
  isLabel = false,
  autofocus = false
}) => {
  var _subjectPermissionsRe, _subjectPermissionsRe2, _propertyDefinitionsR;
  const [isOpen, setIsOpen] = useState(autofocus);
  const {
    objectTypeId,
    objectId,
    asyncData: {
      propertyDefinitionsResult,
      subjectPermissionsResult
    }
  } = useCardContextValue();
  const {
    getDraftValue,
    getSavedValue,
    onSave,
    onChange,
    getPropertyValue
  } = usePropertyInputsContextValue();
  const {
    getPropertyDisplay
  } = usePropertyDisplay(objectTypeId, (_subjectPermissionsRe = (_subjectPermissionsRe2 = subjectPermissionsResult.data) === null || _subjectPermissionsRe2 === void 0 || (_subjectPermissionsRe2 = _subjectPermissionsRe2.crmObject) === null || _subjectPermissionsRe2 === void 0 ? void 0 : _subjectPermissionsRe2.userPermissions.currentUserCanEdit) !== null && _subjectPermissionsRe !== void 0 ? _subjectPermissionsRe : false);
  const propertyDefinition = (_propertyDefinitionsR = propertyDefinitionsResult.data) === null || _propertyDefinitionsR === void 0 ? void 0 : _propertyDefinitionsR.get(propertyName);
  const isEnumProperty = propertyDefinition ? isEnum(castPropertyToAny(propertyDefinition.property)) : false;
  const onOpenChange = useCallback(event => {
    if (isEnumProperty) {
      setIsOpen(event.target.value);
    }
  }, [isEnumProperty]);
  const inputPropsValue = useMemo(() => {
    return Object.assign({
      open: isEnumProperty ? isOpen : undefined
    }, inputProps);
  }, [isEnumProperty, isOpen, inputProps]);
  const formControlPropsValue = useMemo(() => {
    return Object.assign({
      hoverContent: null,
      'data-test-id': `property-input-${propertyName}`,
      marginBlockStart: 0,
      label: null
    }, formControlProps);
  }, [formControlProps, propertyName]);
  if (!propertyDefinition) {
    return null;
  }
  const value = getPropertyValue(propertyName);
  const {
    isReadOnly
  } = getPropertyDisplay(propertyDefinition.property);
  const input = /*#__PURE__*/_jsx(PropertyInputV2, {
    autoFocus: autofocus,
    use: "floating",
    property: propertyDefinition.property,
    objectId: String(objectId),
    objectTypeId: objectTypeId,
    readOnly: isReadOnly || !isEditable,
    inputProps: inputPropsValue,
    formControlProps: formControlPropsValue,
    enableAutosave: true,
    getDraftValue: getDraftValue,
    getSavedValue: getSavedValue,
    onChange: onChange,
    onSave: onSave,
    value: value,
    enableConditionalPropertiesPanel: true,
    enableConditionalPropertyOptions: true,
    onFocus: onFocus,
    onBlur: onBlur,
    onOpenChange: onOpenChange
  }, propertyName);
  return isLabel ? input : /*#__PURE__*/_jsx(InputWrapper, {
    children: input
  });
};
export default PropertyInputWrapper;